var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "landing-cnt-prof row" }, [
        _c("div", {
          staticClass: "landing-child bg-img p-0 p-lg-5",
          staticStyle: { "max-height": "100vh" }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "landing-child container-title-padding text-block-ctn"
          },
          [
            _c("div", { staticClass: "main-block-professional col" }, [
              _c("h1", [_vm._v(_vm._s(_vm.$t("main-professional-block-h1")))]),
              _vm._v(" "),
              _c("h3", [_vm._v(_vm._s(_vm.$t("main-professional-block-h4")))]),
              _vm._v(" "),
              _c("h4", { staticClass: "d-mobile-rotated-none" }, [
                _vm._v(_vm._s(_vm.$t("main-professional-block-h2")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-cnt" },
                [
                  !_vm.$uiHelpers.isMobile
                    ? _c(
                        "router-link",
                        { attrs: { to: "/contacto" } },
                        [
                          _c(
                            "base-button",
                            {
                              staticClass: "btn-landing",
                              staticStyle: {
                                color: "#3238C4",
                                "z-index": "1001",
                                position: "relative"
                              },
                              attrs: { white: "" }
                            },
                            [_vm._v(_vm._s(_vm.$t("prove-free")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$uiHelpers.isMobile
                    ? _c(
                        "router-link",
                        { attrs: { to: "/inicio-sesion" } },
                        [
                          _c(
                            "base-button",
                            {
                              staticClass: "btn-landing",
                              staticStyle: {
                                color: "#3238C4",
                                "z-index": "-1",
                                position: "relative"
                              },
                              attrs: { white: "" }
                            },
                            [_vm._v(_vm._s(_vm.$t("access")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    { attrs: { to: "/pacientes" } },
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "btn-landing-pat",
                          staticStyle: {
                            "border-color": "#4A4A4A",
                            border: "1.5px solid #4A4A4A",
                            "z-index": "-1",
                            position: "relative",
                            color: "#4a4a4a !important"
                          },
                          attrs: { outline: "" }
                        },
                        [_vm._v(_vm._s(_vm.$t("access-patient")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("neu-cards-slider2", {
        staticClass: "py-lg-5 py-0 mt-0 mt-md-5 position-relative",
        attrs: {
          cols: "3",
          cards: _vm.cards,
          blackTitle: _vm.$t("block-2.blackTitle"),
          title: _vm.$t("block-2.title")
        }
      }),
      _vm._v(" "),
      _c(
        "router-link",
        { attrs: { to: "/registro-profesional" } },
        [
          _c(
            "base-button",
            {
              staticClass: "btn mx-auto d-block mb-5",
              attrs: { blue: "", outline: "" }
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("registerfor-free")))])]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          staticClass: "section-invert reverse-sm",
          attrs: { id: "security-data" }
        },
        [
          _c("b-col", { attrs: { md: "12", lg: "6" } }, [
            _c("div", { staticClass: "col-bg ml-lg-auto" })
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "content my-auto", attrs: { md: "12", lg: "6" } },
            [
              _c("h3", [_vm._v(_vm._s(_vm.$t("block-5.blackTitle")))]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "subtitle",
                  staticStyle: { "margin-bottom": "7rem" }
                },
                [_c("p", [_vm._v(_vm._s(_vm.$t("block-5.text2")))])]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  staticClass: "cert-icons",
                  staticStyle: { display: "initial" }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "inline-block" } },
                    [_c("ISO27001Logo")],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "section-white-list", attrs: { id: "incomes-aument" } },
        [
          _c(
            "b-col",
            { staticClass: "content my-auto", attrs: { md: "12", lg: "6" } },
            [
              _c("div", [
                _c("h3", [_vm._v(_vm._s(_vm.$t("block-4.blackTitle")))]),
                _c("h5", [_vm._v(_vm._s(_vm.$t("block-4.title")))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "subtitle" }, [
                _c(
                  "div",
                  { staticClass: "subtitle-list subtitle-list-large" },
                  [
                    _vm._l(
                      [
                        _vm.$t("block-4.text"),
                        _vm.$t("block-4.text2"),
                        _vm.$t("block-4.text3"),
                        _vm.$t("block-4.text4")
                      ],
                      function(item, index) {
                        return _c(
                          "b-row",
                          { key: index },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "tick-mobile",
                                attrs: { cols: "2", md: "1" }
                              },
                              [_c("p", [_c("rounded-check-icon")], 1)]
                            ),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "10" } }, [
                              _c("span", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(item) +
                                    "\n                  "
                                )
                              ])
                            ])
                          ],
                          1
                        )
                      }
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mt-5" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: "/contacto" } },
                          [
                            _c(
                              "base-button",
                              {
                                staticClass: "btn-more-info",
                                attrs: { blue: "", outline: "" }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-size": "1rem" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("more-information-btn"))
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  2
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "py-sm-0 py-lg-5 pl-lg-5 pr-lg-5",
              attrs: { md: "12", lg: "6" }
            },
            [_c("div", { staticClass: "col-bg ml-lg-auto" })]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          staticClass: "section-invert reverse-sm",
          attrs: { id: "offer-service" }
        },
        [
          _c(
            "b-col",
            { staticClass: "no-mobile", attrs: { md: "12", lg: "6" } },
            [
              _c("div", { staticClass: "container-hearth" }, [
                _c(
                  "div",
                  [
                    _c("div", { staticClass: "bg-heart-2" }),
                    _vm._v(" "),
                    _c(
                      "h6",
                      {
                        staticClass: "centered-title",
                        staticStyle: { position: "absolute" }
                      },
                      [_vm._v(_vm._s(_vm.$t("ask-for-demo-title")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      { attrs: { to: "/contacto" } },
                      [
                        _c(
                          "base-button",
                          {
                            staticClass: "btn centered-button my-auto",
                            staticStyle: {
                              "margin-bottom": "10rem",
                              "z-index": "50",
                              position: "absolute",
                              left: "49.5%"
                            },
                            attrs: { blue: "", outline: "" }
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("ask-for-demo")))])]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "content my-auto", attrs: { md: "12", lg: "6" } },
            [
              _c("div", { staticStyle: { display: "inline-block" } }, [
                _c("h3", [_vm._v(_vm._s(_vm.$t("block-3.blackTitle")))]),
                _c("h5", [_vm._v(_vm._s(_vm.$t("block-3.title")))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "subtitle" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("block-3.text")))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "subtitle" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("block-3.text2")))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "subtitle" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("block-3.text3")))])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.inMx
        ? _c("neu-cards-slider-pricing-professionals", {
            staticClass: "section",
            attrs: {
              white: true,
              cards: _vm.cardsPricing,
              cards2: _vm.cardsPricing2,
              cards3: _vm.cardsPricingComission,
              title: _vm.$t("block-8.title"),
              iva: _vm.$t("block-8.iva")
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.inMx
        ? _c(
            "b-row",
            {
              staticClass: "section-black-list reverse-sm",
              attrs: { id: "opensalud4all" }
            },
            [
              _c(
                "b-col",
                {
                  staticClass: "content my-auto",
                  attrs: { md: "12", lg: "6" }
                },
                [
                  _c("div", { staticClass: "d-inline-block" }, [
                    _c("h3", [_vm._v(_vm._s(_vm.$t("block-7.blackTitle")))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "subtitle",
                      staticStyle: { "font-weight": "bold" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "subtitle-list subtitle-list-large mt-sm-3"
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "mb-3" },
                            [
                              _c("b-col", { attrs: { cols: "12" } }, [
                                _c(
                                  "span",
                                  { staticStyle: { display: "inline-block" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          color: "white",
                                          display: "inline-block"
                                        }
                                      },
                                      [_vm._v("opensalud4all")]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("block-7.text1")) +
                                        "\n                   "
                                    ),
                                    _c("br"),
                                    _c("br"),
                                    _vm._v(
                                      "\n                   " +
                                        _vm._s(_vm.$t("block-7.text2")) +
                                        "\n                   "
                                    ),
                                    _c("br"),
                                    _c("br"),
                                    _vm._v(
                                      "\n                   " +
                                        _vm._s(_vm.$t("block-7.text3")) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "btn-more-info-white mt-5",
                      staticStyle: { color: "white" },
                      attrs: { white: "", outline: "" },
                      on: { click: _vm.goToOpensalud4allLanding }
                    },
                    [
                      _c("span", { staticStyle: { color: "white" } }, [
                        _vm._v(_vm._s(_vm.$t("more-information-btn")))
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "12", lg: "6" } }, [
                _c("div", { staticClass: "col-bg ml-lg-auto" })
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b39112d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b39112d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/opensalud/Profesionales.vue
// module id = 3714
// module chunks = 51